import { ISettings, TSettingsValue } from '@shared/contexts/SettingsContext';
import { Document as RTDocument } from '@contentful/rich-text-types';

export function isRichText(value: unknown): value is RTDocument {
    if (typeof value === 'object' && value !== null) {
        return 'nodeType' in value;
    }
    return false;
}

/**
 * Retrieves a label from component settings or Contentful.
 * @param keys - Array of keys to traverse settings.
 * @param componentSettings - Optional settings object to read from.
 * @param shouldUseFallback - When true, returns keys.join('.') if label is missing (matches client-side behavior).
 * @returns The label string or rich text document, fallback if useFallback is true, or undefined when missing.
 */
export function getLabel(
    keys: string[],
    componentSettings?: ISettings,
    shouldUseFallback?: boolean,
): string | RTDocument | undefined {
    let current: TSettingsValue = componentSettings;
    const fallback = shouldUseFallback ? keys.join('.') : undefined;

    for (const key of keys) {
        if (current && typeof current === 'object' && !isRichText(current) && key in current) {
            current = current[key];
        } else {
            return fallback;
        }
    }

    if (typeof current === 'string' || isRichText(current)) {
        return current;
    }

    return fallback;
}
